import { render, staticRenderFns } from "./dashboard-status-shared.vue?vue&type=template&id=378ed47c"
import script from "./dashboard-status-shared.vue?vue&type=script&lang=js"
export * from "./dashboard-status-shared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports